export default __webpack_public_path__ + "static/media/cats.250e53d3.jpg";